import { ComponentProps, forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { Type, TypeVariant } from "@shared/ui/Type";

type LabelProps = ComponentProps<"label"> & {
  variant?: "default" | "error";
  required?: boolean;
  error?: boolean;
  id?: string;
  typeVariant?: TypeVariant;
};

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  (
    {
      className,
      variant,
      required = false,
      error,
      id,
      children,
      typeVariant = "caption",
      ...props
    },
    ref
  ) => (
    <Type
      ref={ref}
      as="label"
      variant={typeVariant}
      id={id}
      className={twMerge(
        "text-brand-700 font-medium peer-disabled:cursor-not-allowed peer-disabled:text-brand-300",
        variant === "error" && "text-error",
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="text-error ml-0.5">*</span>}
    </Type>
  )
);

export default Label;
